import { PureComponent } from "react";
import { type RouteComponentProps, withRouter } from "react-router";

import { routes } from "utilities/routes";

import { RelatedItemType } from "commonComponents/entity/relatedItem/RelatedItem.types";
import { RelatedItemTag } from "commonComponents/entity/relatedItem/RelatedItemTag/RelatedItemTag";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
    type IEntityLinkResponse,
} from "commonComponents/utilities/Grid/GridContainer.types";

export class RelatedOwnerInvoicesCellInternal extends PureComponent<
    IGridCellRenderProps<IEntityLinkResponse[]> & RouteComponentProps
> {
    render() {
        const { cellValue, field } = this.props;
        if (!cellValue) {
            return null;
        }

        return (
            <div data-testid={field.full}>
                {cellValue.map((oi) => (
                    <RelatedItemTag
                        key={oi.id}
                        data-testid={`${field.full}_${oi.id}`}
                        itemType={RelatedItemType.CustomerInvoice}
                        to={routes.ownerInvoice.getDetailsPath(oi.id, oi.jobId!)}
                        subject={oi.title}
                        useMultiTagMargins
                    />
                ))}
            </div>
        );
    }
}

export const RelatedOwnerInvoicesCell = withRouter(RelatedOwnerInvoicesCellInternal);

export const columnRelatedOwnerInvoices: IClientGridColumn<IEntityLinkResponse[]> = {
    columnType: GridColumnType.relatedOwnerInvoicesLink,
    Cell: RelatedOwnerInvoicesCell,
};
